module.exports = __webpack_public_path__ + "img/zambia-logo-icon.5ef435bd.png";